import { Resource } from './resource';
import { User } from './user';
import { JobCategory } from './jobCategory';
import { JobRole } from './jobRole';
import { Status } from './status';
import { Priority } from './Priority';
import { Technology } from './technology';
import { JobDescription } from './jobDescription';
import { JobRecruiter } from './jobRecruiter';

export class JobPositionDTO extends Resource {
  code: String;
  name: String;
  description: String;
  jobCategory: JobCategory;
  jobPosition: JobRole;
  //don't know that we will set <user> here or in backend
  jobEmploymentType: String;
  //as discussed we will keep the job status as open ended while creation so dont know
  jobStatus: Status;
  skill: String;
  jobPriority: Priority;
  technology: Technology;
  noOfVacancies: number;
  jobDescription: JobDescription;
  jobAssignedRecruiter : JobRecruiter;
  user: User;
  jdFileURL: String;
  openJobCount: Number;
  closedJobCount: Number;
  pendingJobCount: Number;
}